'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useEventListener } from 'usehooks-ts';
const isScrolledPast = () => window.scrollY > window.innerHeight;

/**
 * Whether the page is scrolled further down than one viewport height — the
 * point at which a list page's filters and sorting are definitively off-screen.
 */
export const useScrolledPastViewport = () => {
  const $ = _c(5);
  const [isPastViewport, setIsPastViewport] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsPastViewport(isScrolledPast());
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const update = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      passive: true
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useEventListener("scroll", update, undefined, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      passive: true
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEventListener("resize", update, undefined, t2);
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsPastViewport(isScrolledPast());
    };
    t4 = [];
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  return isPastViewport;
};